import * as React from 'react'

const DEFAULTS = {
  MAPS_API_KEY: '123',
  SIGNIN_CLIENT_ID: '123',
}

const GoogleContext = React.createContext(DEFAULTS)

export default GoogleContext



// WEBPACK FOOTER //
// ./src/components/GoogleContext/GoogleContext.tsx